import * as React from 'react';

export const useDisableBodyScroll = (enabled: boolean): void => {
  React.useEffect(() => {
    if (!enabled) return;
    const originalOverflow = document.body.style.overflow;
    const originalPosition = document.body.style.position;
    const originalTouchAction = document.body.style.touchAction;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollTop}px`;
    document.body.style.width = '100%';
    document.body.style.touchAction = 'none';

    /**
     * This is to prevent the user from scrolling the background when the mobile nav is open
     */
    const preventScroll = (e: Event) => {
      const target = e.target as Element;
      if (e.target && e.target === document) return;

      const navigationMain = target?.closest('.mwg-navigation__Main');
      const navigationSubnav = target?.closest('.mwg-navigation__SubNav');

      /** Allows scrolling within navigation itself */
      if (navigationMain || navigationSubnav) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();
    };

    document.addEventListener('wheel', preventScroll, { passive: false });
    document.addEventListener('touchmove', preventScroll, { passive: false });
    document.addEventListener('scroll', preventScroll, { passive: false });

    // eslint-disable-next-line consistent-return
    return () => {
      document.removeEventListener('wheel', preventScroll);
      document.removeEventListener('touchmove', preventScroll);
      document.removeEventListener('scroll', preventScroll);

      document.body.style.overflow = originalOverflow;
      document.body.style.position = originalPosition;
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.touchAction = originalTouchAction;

      window.scrollTo(0, scrollTop);
    };
  }, [enabled]);
};
